module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/typography-393b0221b33b12302928beb6200161df.jpg";